import type { RatingValue } from '@frontend/api-types';
import { RATING_OPTIONS, TASK_RATING_TO_EMOJI_MAP } from '@frontend/constants';
import { XStack } from './Containers/Stacks/XStack';
import { YStack } from './Containers/Stacks/YStack';
import { Text } from './Texts/Text';

type RatingOptionsInputProps = {
  onChange: (rating: RatingValue) => void;
  value: MaybeUndefined<RatingValue>;
};

export const RatingOptions = ({ onChange, value }: RatingOptionsInputProps) => (
  <XStack className="justify-between">
    {RATING_OPTIONS.map((option) => {
      const isSelected = value === option;
      return (
        <YStack
          bg={isSelected ? 'neutral100' : 'transparent'}
          centered
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="size-[52px] hover:bg-neutral-100 hover:ease-in hover:duration-100"
          key={option}
          onClick={() => onChange(option)}
          px="md"
          radius="full"
        >
          <Text isSelectable={false} type="h1">
            {TASK_RATING_TO_EMOJI_MAP[option]}
          </Text>
        </YStack>
      );
    })}
  </XStack>
);
